module.exports = __webpack_public_path__ + "static/media/happy_birthday_big.ec6fcb65.svg";